module.exports = {
  siteUrl: 'https://www.discordeon.com',
  sitemapPath: '/sitemap.xml',
  title: 'Discordéon',
  description: "Le projet Discordéon est né de l'envie de faire dialoguer des mondes musicaux différents autour de l'accordéon, et bien plus encore...",
  author: '@oliviergenevest',
  locales: {fr:
    {
      path: 'fr',
      name: 'Français',
      default: true
    },
/*    en:
    {
      path: 'en',
      name: 'English'
    }*/
  },

};
